import { confirmDialog } from "primereact/confirmdialog";
import { createWard, deleteWard, updateWard, getAllWards, mergeWards } from "../../services/ValitanApiService";
import { enqueueSnackbar } from "notistack";

export const mergeWardsApi = async (sourceWardIds, targetWardId) => {
  try {
    const response = await mergeWards({
      source_ward_ids: sourceWardIds,
      target_ward_id: targetWardId
    });
    if (response.data.status === "success") {
      enqueueSnackbar(response.data.message || "Wards merged successfully.", { variant: "success" });
      return true;
    } else {
      enqueueSnackbar(response.data.message || "Failed to merge wards.", { variant: "error" });
      return false;
    }
  } catch (error) {
    console.error("Error merging wards:", error);
    enqueueSnackbar("Error merging wards. Please try again.", { variant: "error" });
    return false;
  }
};

// Fetch Wards
export const getWards = async (page = 0, size = 10) => {
  try {
    const response = await getAllWards(page, size);
    console.log("Response status: ", response.data.status);
    if (response.data.status === "success") {
      const field = response.data.data;
      console.log("Kata zote: ", response);
      return {
        wards: field.content,
        paginationInfo: {
          totalElements: field.total_elements,
          totalPages: field.total_pages,
          pageNumber: field.number,
          pageSize: field.size,
          sort: field.sort,
        },
      };
    } else {
      enqueueSnackbar(response.data.message || "Failed to fetch wards.", { variant: "error" });
      return { wards: [], paginationInfo: {} };
    }
  } catch (error) {
    console.error("Error fetching wards:", error);
    enqueueSnackbar("Error fetching wards. Please try again.", { variant: "error" });
    return { wards: [], paginationInfo: {} };
  }
};



// Delete ward
export const deleteAWard = async (id, loadWards) => {
  try {
    const response = await deleteWard(id);
    if (response.data.status === "success") {
      enqueueSnackbar(response.data.message, { variant: "success" });
      await loadWards();
    } else {
      enqueueSnackbar(response.data.message || "Failed to delete ward.", { variant: "error" });
    }
  } catch (error) {
    enqueueSnackbar("Failed to delete ward. Please try again.", { variant: "error" });
    console.error(error);
  }
};

export const confirmDelete = (id, loadWards) => {
  confirmDialog({
    message: "Are you sure you want to delete this ward?",
    header: "Confirmation",
    icon: "pi pi-question-circle",
    accept: () => deleteAWard(id, loadWards),
    reject: () => { },
  });
};

// Validation on create or update
export const validateWardForm = (wardName, selectedDistrict, setErrors) => {
  let valid = true;
  const errorsCopy = { wardName: "", district: "" };

  if (wardName.trim()) {
    errorsCopy.wardName = "";
  } else {
    errorsCopy.wardName = "Ward Name is required";
    valid = false;
  }

  if (selectedDistrict && selectedDistrict.value) {
    errorsCopy.district = "";
  } else {
    errorsCopy.district = "District is required";
    valid = false;
  }

  setErrors(errorsCopy);
  return valid;
};


// Create or update ward
export const createOrUpdateWard = async (
  event,
  wardName,
  selectedDistrict,
  editingWardId,
  loadWards,
  toggleModal,
  setErrors
) => {
  event.preventDefault();

  if (!validateWardForm(wardName, selectedDistrict, setErrors)) {
    return;
  }

  // Prepare payload with correct structure
  const wardData = { 
    name: wardName, 
    district: { id: selectedDistrict.value } // Include selectedDistrict
  };

  try {
    const response = editingWardId
      ? await updateWard(editingWardId, wardData)
      : await createWard(wardData);

    if (response.data.status === "success") {
      enqueueSnackbar(response.data.message, { variant: "success" });
      toggleModal();
      await loadWards();
    } else {
      enqueueSnackbar(response.data.message || "Failed to save ward data.", { variant: "error" });
    }
  } catch (error) {
    console.error("Error saving ward data:", error);
    enqueueSnackbar("Error saving ward data. Please try again.", { variant: "error" });
  }
};

